import { render, staticRenderFns } from "./FluxTransition.vue?vue&type=template&id=63dba382&"
import script from "./FluxTransition.vue?vue&type=script&lang=js&"
export * from "./FluxTransition.vue?vue&type=script&lang=js&"
import style0 from "./FluxTransition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports